import { performPostRequest } from '@atlassian/jira-fetch';
import type { RestGenerateProjectKeyPayload, RestGenerateProjectKeyResponse } from './types';

export const constructEndpoint = () => '/rest/simplified/latest/project/generateKey';

export const post = (
	baseUrl: string,
	payload: RestGenerateProjectKeyPayload,
): Promise<RestGenerateProjectKeyResponse> => {
	const url = constructEndpoint();
	const options = {
		body: JSON.stringify(payload),
	};
	return performPostRequest(url, options);
};
